import './App.css';
import { motion } from 'framer-motion';
import icp_logo from './icp_logo.png';
import ga_logo from './ga_logo.png';

function App() {
  return (
    <div className="App">
      {/* 导航栏 */}
      <nav className="navbar">
        <div className="logo">命令备忘录</div>
        <div className="nav-links">
          <a href="#features">分类</a>
          <a href="#about">关于</a>
          <a href="#contact">联系</a>
        </div>
      </nav>

      {/* Hero Section */}
      <motion.section 
        className="hero"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <h1>您的命令速查手册</h1>
        <p>快速查找、学习和使用各类常用命令</p>
        <button className="cta-button">开始使用</button>
      </motion.section>

      {/* 特色功能展示 */}
      <section className="features" id="features">
        <h2>常用工具</h2>
        <div className="feature-grid">
          {[
            { url: 'https://ai-account.site/nextcloud', title: '个人网盘', description: '安全便捷的云端存储空间' },
            { url: 'https://ai-account.site/reference/', title: '命令速查', description: '快速查找和学习各类实用命令' },
            { url: 'https://ai-account.site/wiki', title: '个人文档', description: '系统化的知识管理与分享平台' },
            { url: 'https://ai-account.site/easy-image/', title: '图片仓库', description: '图片存储与分享平台' },
            { url: 'https://ai-account.site/notepad/', title: 'AI笔记', description: '临时笔记，随时随地记录灵感' },
            {
              url: 'https://ai-account.site/tools', title: '开发工具箱', description: '常用开发工具集合'}
          ].map((item, index) => (
            <motion.div 
              key={index}
              className="feature-card"
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <h3>{item.title}</h3>
              <p>{item.description}</p>
              <a href={item.url} className="feature-link">查看详情 →</a>
            </motion.div>
          ))}
        </div>
      </section>

      {/* 页脚 */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h4>联系我们</h4>
            <p>Email: contact@ai-account.site</p>
          </div>
          <div className="footer-section">
            <h4>快速链接</h4>
            <div className="footer-links">
              <a href="/privacy" className="footer-link">隐私政策</a>
              <a href="/terms" className="footer-link">使用条款</a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 命令备忘录. All rights reserved.</p>
          <div className="beian-container">
            <a 
              href="https://beian.miit.gov.cn/" 
              target="_blank"
              rel="noopener noreferrer"
              className="beian-link"
            >
              <img src={icp_logo} alt="ICP备案" className="beian-icon" />
              赣ICP备2024044024号
            </a>
            <a 
              href="https://beian.mps.gov.cn/#/query/webSearch?code=36090202000315" 
              target="_blank"
              rel="noopener noreferrer"
              className="beian-link"
            >
              <img src={ga_logo} alt="公安备案" className="beian-icon" />
              赣公网安备36090202000315
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
